import {
  FETCH_COLLECTIONS,
  TOGGLE_COLLECTION_PAGE_NECKLACE_OVERLAY,
  TOGGLE_COLLECTION_PAGE_OVERLAY,
  TOGGLE_HOLDER_RING_COLLECTIONS,
  TOGGLE_MAIN_RING_COLLECTIONS,
} from "./types";

import ContentfulApi from "../../lib/ContentfulApi";

export const fetchCollections = () => {
  return (dispatch) => {
    const api = new ContentfulApi();

    api
      .getCollections()
      .then((response) => {
        if (response.items && response.includes) {
          const formattedCollections = formatCollections(response);
          dispatch({
            type: FETCH_COLLECTIONS,
            payload: formattedCollections,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const toggleCollectionPageOverlay = (page = "collection") => {
  return (dispatch) => {
    if (page === "collection") {
      dispatch({
        type: TOGGLE_COLLECTION_PAGE_OVERLAY,
      });
    } else {
      dispatch({
        type: TOGGLE_COLLECTION_PAGE_NECKLACE_OVERLAY,
      });
    }
  };
};

const formatCollections = (collectionResponse) => {
  const formattedCollections = {
    items: [],
  };
  if (collectionResponse) {
    formattedCollections.items = collectionResponse.items.map((item) => {
      item.fields.id = item.sys.id;
      item.fields.galleryImageList = [];
      if (collectionResponse.includes && collectionResponse.includes.Asset) {
        for (let i = 0; i < collectionResponse.includes.Asset.length; i++) {
          if (
            item.fields.image &&
            item.fields.image.sys.id ===
              collectionResponse.includes.Asset[i].sys.id
          ) {
            item.fields.imageURL =
              "https://" +
              collectionResponse.includes.Asset[i].fields.file.url.substring(2);
          }
          if (item.fields.galleryImages) {
            for (let y = 0; y < item.fields.galleryImages.length; y++) {
              if (
                item.fields.galleryImages[y].sys.id ===
                collectionResponse.includes.Asset[i].sys.id
              ) {
                item.fields.galleryImageList.push({
                  url:
                    "https://" +
                    collectionResponse.includes.Asset[
                      i
                    ].fields.file.url.substring(2),
                  title: collectionResponse.includes.Asset[i].fields.title,
                });
              }
            }
          }
        }
      }
      return item.fields;
    });
    return formattedCollections;
  }
};

export const toggleMainRingCollections = (id) => {
  return (dispatch) => {
    if (id) {
      dispatch({
        type: TOGGLE_MAIN_RING_COLLECTIONS,
        payload: id,
      });
    }
  };
};

export const toggleHolderRingCollections = (id) => {
  return (dispatch) => {
    if (id) {
      dispatch({
        type: TOGGLE_HOLDER_RING_COLLECTIONS,
        payload: id,
      });
    }
  };
};
